var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697L15.9697 2.46967C16.2626 2.17678 16.7374 2.17678 17.0303 2.46967C17.3232 2.76256 17.3232 3.23744 17.0303 3.53033L8.56066 12L17.0303 20.4697C17.3232 20.7626 17.3232 21.2374 17.0303 21.5303C16.7374 21.8232 16.2626 21.8232 15.9697 21.5303L6.96967 12.5303Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeChevronLeft);
export default __webpack_public_path__ + "static/media/loree-chevron-left.f777f48bcaf1884792836873d07ea12b.svg";
export { ForwardRef as ReactComponent };